module.exports = __webpack_public_path__ + "img/exam-icon.c5e6418f.png";